module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Open Space Technology")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "CSS_1.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "pageii"
    }
  }, [_c('p', [_c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('h1', [_c('b', [_vm._v("    Also by Harrison Owen ")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e303"
    }
  }, [_c('i', [_vm._v("Spirit: Transformation and Development in Organizations ")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e353"
    }
  }, [_c('i', [_vm._v("Leadership Is ")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e403"
    }
  }, [_c('i', [_vm._v("Riding the Tiger ")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e453"
    }
  }, [_c('i', [_vm._v("The Millennium Organization ")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e513"
    }
  }, [_c('i', [_vm._v("Tales From Open Space ")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e563"
    }
  }, [_c('i', [_vm._v("Expanding Our Now: The Story of Open Space Technology ")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e613"
    }
  }, [_c('i', [_vm._v("The Power of Spirit: How Organizations Transform ")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e663"
    }
  }, [_c('i', [_vm._v("The Spirit of Leadership ")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e713"
    }
  }, [_c('i', [_vm._v("Wave Rider: Leadership for High Performance in a ")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e763"
    }
  }, [_c('i', [_vm._v("          Self-Organizing World ")]), _c('br'), _c('br')])])]), _c('a', {
    attrs: {
      "id": "pageii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a693a43","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AlsobyHarrisonOwen.vue
// module id = 60
// module chunks = 0